import {
  HashRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import UnityComponent from "./unity.component";
import ClientConnectorTestPage from "./ClientConnectorTestPage";
import Builds from "./builds.component";
import { logger } from "@games/logger-client";

// Тип для пропсов RouteCleaner
interface RouteCleanerProps {
  children: React.ReactNode;
}

// Компонент для очистки некорректных маршрутов
const RouteCleaner = ({ children }: RouteCleanerProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    logger.componentMount("RouteCleaner");

    // Проверяем текущий маршрут
    const checkAndRedirect = () => {
      const hash = window.location.hash.slice(1); // Убираем #
      if (
        hash.includes("tgWebAppData") ||
        hash.includes("tgWebAppPlatform") ||
        location.pathname.includes("tgWebAppData") ||
        location.pathname.includes("tgWebAppPlatform")
      ) {
        logger.navigation("🔄 Detected Telegram params, redirecting to /main");
        navigate("/main", { replace: true });
      }
    };

    // Проверяем при загрузке
    checkAndRedirect();

    // Слушаем изменения хэша
    window.addEventListener("hashchange", checkAndRedirect);

    // Очищаем слушатель при размонтировании
    return () => {
      window.removeEventListener("hashchange", checkAndRedirect);
      logger.componentUnmount("RouteCleaner");
    };
  }, [navigate, location.pathname]);

  return children;
};

// Компонент для отображения initData из Telegram WebApp
const InitDataPage = () => {
  const navigate = useNavigate();
  const initData = window.Telegram?.WebApp?.initData || "Init Data не доступен";

  useEffect(() => {
    logger.componentMount("InitDataPage");
    return () => {
      logger.componentUnmount("InitDataPage");
    };
  }, []);

  const buttonStyle = {
    display: "block",
    margin: "10px 0",
    padding: "10px 15px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    width: "300px",
    fontSize: "16px",
  };

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1>Telegram WebApp Init Data</h1>
      <div
        style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f5f5f5",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "80%",
          wordBreak: "break-all",
          fontFamily: "monospace",
        }}
      >
        {initData}
      </div>
      <button style={buttonStyle} onClick={() => navigate("/main")}>
        Вернуться к списку сборок
      </button>
    </div>
  );
};

// Компонент для выбора токена
const TokenSelectionPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedBuild = searchParams.get("build") || "";

  useEffect(() => {
    logger.componentMount("TokenSelectionPage");
    return () => {
      logger.componentUnmount("TokenSelectionPage");
    };
  }, []);

  const launchUnity = (tokenIndex?: number) => {
    const url =
      tokenIndex !== undefined
        ? `/unity?build=${encodeURIComponent(selectedBuild)}&token=${tokenIndex}`
        : `/unity?build=${encodeURIComponent(selectedBuild)}`;
    logger.navigation(
      `🎮 Launching Unity with build: ${selectedBuild}, tokenIndex: ${
        tokenIndex !== undefined ? tokenIndex : "undefined"
      }`
    );
    navigate(url);
  };

  const buttonStyle = {
    display: "block",
    margin: "10px 0",
    padding: "10px 15px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    width: "300px",
    fontSize: "16px",
  };

  const buttonStyleWrong = {
    display: "block",
    margin: "10px 0",
    padding: "10px 15px",
    backgroundColor: "#d32f2f",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    width: "300px",
    fontSize: "16px",
  };

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1>Выбор токена для сборки: {selectedBuild}</h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <button style={buttonStyle} onClick={() => launchUnity(0)}>
          Unity с токеном #1
        </button>
        <button style={buttonStyle} onClick={() => launchUnity(1)}>
          Unity с токеном #2
        </button>
        <button style={buttonStyle} onClick={() => launchUnity(2)}>
          Unity с токеном #3
        </button>
        <button style={buttonStyle} onClick={() => launchUnity(3)}>
          Unity с токеном #4
        </button>
        <button style={buttonStyle} onClick={() => launchUnity(4)}>
          Unity с токеном #5
        </button>
        <button style={buttonStyle} onClick={() => launchUnity(5)}>
          Unity с токеном #6
        </button>     
                <button style={buttonStyle} onClick={() => launchUnity(6)}>
          Unity с токеном #7
        </button>     
                <button style={buttonStyle} onClick={() => launchUnity(7)}>
          Unity с токеном #8
        </button>     
                <button style={buttonStyle} onClick={() => launchUnity(8)}>
          Unity с токеном #9
        </button>     
                <button style={buttonStyle} onClick={() => launchUnity(9)}>
          Unity с токеном #10
        </button>     
                <button style={buttonStyle} onClick={() => launchUnity(10)}>
          Unity с токеном 11
        </button>     
                <button style={buttonStyle} onClick={() => launchUnity(11)}>
          Unity с токеном #12
        </button>        
        <button style={buttonStyleWrong} onClick={() => launchUnity()}>
          Unity с ошибочным токеном
        </button>
      </div>
    </div>
  );
};

// Компонент Builds с кнопкой для initData
export const ModifiedBuilds = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logger.componentMount("ModifiedBuilds");
    return () => {
      logger.componentUnmount("ModifiedBuilds");
    };
  }, []);

  const viewInitData = () => {
    logger.navigation("📋 Navigating to init-data page");
    navigate("/init-data");
  };

  const viewTestClient = () => {
    logger.navigation("🧪 Navigating to test-client page (no Unity)");
    navigate("/test-client?token=0");
  };

  return (
    <>
      <Builds />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={viewTestClient}
          style={{
            padding: "10px 15px",
            backgroundColor: "#FF9800",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            width: "300px",
            fontSize: "16px",
          }}
        >
          Тест clientConnector (без Unity)
        </button>
        <button
          onClick={viewInitData}
          style={{
            padding: "10px 15px",
            backgroundColor: "#2196F3",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            width: "300px",
            fontSize: "16px",
          }}
        >
          Показать Init Data
        </button>
      </div>
    </>
  );
};

// Основной компонент приложения
export const App = () => {
  useEffect(() => {
    logger.componentMount("App");
    return () => {
      logger.componentUnmount("App");
    };
  }, []);

  return (
    <HashRouter>
      <RouteCleaner>
        <Routes>
          <Route path="/main" element={<ModifiedBuilds />} />
          <Route path="/tokens" element={<TokenSelectionPage />} />
          <Route path="/unity" element={<UnityComponent />} />
          <Route path="/test-client" element={<ClientConnectorTestPage />} />
          <Route path="/init-data" element={<InitDataPage />} />
          <Route path="/" element={<Navigate to="/main" replace />} />
        </Routes>
      </RouteCleaner>
    </HashRouter>
  );
};

export default App;